import React from "react";
import "./Footer.css";
import { NavLink } from "react-router-dom";
import { selectSimpleMode } from "../../store/globalSlice";
import { useSelector } from "react-redux";

const Footer = () => {
  const simpleMode = useSelector(selectSimpleMode);
  const hyperText = simpleMode ? "s-m-footer-a-txt" : "footer-a-txt";
  return (
    <footer
      className="footer"
      style={{
        background: simpleMode ? "#001650" : "#00e6d7",
        color: simpleMode ? "#fff" : "#000",
      }}
    >
      <div className="footer-content">
        <div className="footer-section">
          <h2 className={simpleMode ? "s-m-f-txt" : "footer-txt"}>
            Contact Us
          </h2>
          <p>Email: zivotixhq@gmail.com</p>
          <p>Phone: (+91) 9625 313 493</p>
        </div>

        <div className="footer-section">
          <h2 className={simpleMode ? "s-m-f-txt" : "footer-txt"}>
            Quick Links
          </h2>
          <ul>
            <li className={hyperText}>
              <NavLink to="/">Home</NavLink>
            </li>
            <li className={hyperText}>
              <NavLink to="/about">About</NavLink>
            </li>
            <li className={hyperText}>
              <NavLink to="/services">Services</NavLink>
            </li>
            <li className={hyperText}>
              <NavLink to="/contact">Contact</NavLink>
            </li>
          </ul>
        </div>

        <div className="footer-section">
          <h2 className={simpleMode ? "s-m-f-txt" : "footer-txt"}>
            Social Media
          </h2>
          <p>Follow us on:</p>
          <div className="social-icons"></div>
        </div>
      </div>

      <div className={simpleMode ? "s-m-footer-bottom" : "footer-bottom"}>
        <p>&copy; 2024 Zivotix Pvt. Limited. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;
